import React, { useState, useEffect, useContext, useRef } from 'react';
import {
	Container,
	Stack,
	AppBar,
	Toolbar,
	Typography,
	IconButton,
	TableContainer,
	Table,
	TableCell,
	TableRow,
	TableHead,
	TableBody,
	Dialog
} from '@mui/material';
import { isEmpty } from 'lodash';

import { DataContext } from '../../../context/DataContext';

import { getRol, getToken, getUser } from '../../../api/Account';
import NoData from '../../../components/NoData';
import { getCarteraCreditoAsync } from '../../../api/Report';

import moment from 'moment';

import { simpleMessage } from '../../../helpers/Helpers';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx/xlsx.mjs';

const ReporteCarteraCredito = () => {
	const [data, setData] = useState([]);

	const { setIsLoading, setIsUnautorized, title, slogan, icon } = useContext(DataContext);

	const compRef = useRef();

	const token = getToken();
	const user = getUser();
	const rol = getRol();

	const getData = async () => {
		setIsLoading(true);
		const result = await getCarteraCreditoAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setData(result.data.result);
		setIsLoading(false);
	};

	useEffect(() => {
		getData();
	}, []);

	const pageStyle = `
      @media print {
        html, body {
          height: initial !important;
          overflow: initial !important;
          -webkit-print-color-adjust: exact;
        }
      }
      @media all {
        .pagebreak {
          display: none;
        }
      }
      @media print {
        .pagebreak {
          page-break-before: always;
        }
      }  
      @page { size: landscape;  margin: 5mm; }
    `;

	const exportExcel = () => {
		let exp = [];
		data.map((item) => {
			let obj = {
				Cliente: item.numeroCliente,
				'Nombre Cliente': item.clientName,
				Documento: item.identification,
				'F.Nacimiento': item.fechaNacimiento,
				'Sector Negocio': item.actividadEconomica,
				Direccion: item.address,
				Telefono: item.phone,
				'Telefono 2': '-',
				'Empresa Trabajo': item.company,
				'Direccion Empresa': item.companyAddress,
				Cargo: item.actividadEconomica,
				'T.Ingresos': item.totalIngresos,
				'#Credito': item.numeroCredito,
				'Nombre Tienda': item.description,
				'F.Entrega': item.fechaEntrega,
				Vendedor: item.gestorName,
				Plazo: item.plazo,
				Frecuencia: item.periocidad,
				'Cuota Teorica': item.cuotaTeorica,
				'Cuota Credito': item.cuotaPagar,
				'Tasa Int.': `${item.intCorriente} %`,
				Vence: item.fechaVencimiento,
				'Dias Mora': item.atrasoDias,
				'Rango Mora':
					item.atrasoDias >= 0 && item.atrasoDias <= 30
						? '0 - 30'
						: item.atrasoDias > 30 && item.atrasoDias <= 60
						? '31 - 60'
						: item.atrasoDias > 60 && item.atrasoDias <= 90
						? '61 - 90'
						: item.atrasoDias > 91 && item.atrasoDias <= 120
						? '91 - 120'
						: '120+',
				'F.Ultimo Pago': item.fechaUltimoAbono
			};
			exp.push(obj);
		});

		var bk = XLSX.utils.book_new(),
			bs = XLSX.utils.json_to_sheet(exp);

		XLSX.utils.book_append_sheet(bk, bs, 'carteraCredito');
		XLSX.writeFile(bk, 'CarteraCredito.xlsx');
	};

	return (
		<div>
			<Dialog fullScreen open={true}>
				<AppBar sx={{ position: 'relative' }}>
					<Toolbar>
						<Typography
							sx={{ ml: 2, flex: 1, textAlign: 'center' }}
							variant="h5"
							component="div"
						>
							{`${title} `}
						</Typography>
					</Toolbar>
				</AppBar>

				<Stack display="flex" justifyContent="center">
					<Stack
						direction={'row'}
						justifyContent="space-between"
						paddingLeft={5}
						paddingRight={5}
						marginTop={1}
						marginBottom={1}
					>
						<IconButton variant="outlined" onClick={() => exportExcel()}>
							<FontAwesomeIcon
								icon={faCloudArrowDown}
								style={{ fontSize: 40, color: '#00a152', width: 40 }}
							/>
						</IconButton>

						<Stack>
							<Typography
								sx={{
									color: '#2196f3',
									textAlign: 'center',
									fontWeight: 'bold'
								}}
							>
								{slogan}
							</Typography>
							<Typography
								sx={{
									color: '#2196f3',
									textAlign: 'center',
									fontWeight: 'bold'
								}}
								variant="h6"
								component="div"
							>
								Reporte Cartera de Crédito
							</Typography>
						</Stack>

						<Stack>
							<Typography
								sx={{
									color: '#2196f3',
									textAlign: 'left'
								}}
								fontSize={11}
							>
								Usuario:
							</Typography>
							<Typography fontSize={11} textAlign="left">
								{user}
							</Typography>
							<Typography fontSize={11} textAlign="left">
								{rol}
							</Typography>
							<Typography fontSize={11} textAlign="left">
								{`Fecha y hora: ${moment().format('DD/MM/YYYY hh:mm A')}`}
							</Typography>
						</Stack>
						{/* <ReactToPrint
							trigger={() => {
								return (
									<IconButton
										variant="outlined"
										// style={{ position: "fixed", right: 20, top: 75 }}
									>
										<PrintRoundedIcon
											style={{ fontSize: 40, color: '#2979ff', width: 40 }}
										/>
									</IconButton>
								);
							}}
							content={() => compRef.current}
							pageStyle={pageStyle}
						/> */}
					</Stack>

					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<Stack direction={'row'} justifyContent="right"></Stack>
					</Container>
				</Stack>

				<Container maxWidth={false} sx={{ textAlign: 'center' }}>
					<hr />
					{isEmpty(data) ? (
						<NoData />
					) : (
						<>
							<TableContainer>
								<Table aria-label="simple table" size="small">
									<TableHead>
										<TableRow>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Cliente
											</TableCell>

											<TableCell
												align="left"
												className="text-primary fw-bold"
											>
												Nombre Cliente
											</TableCell>

											<TableCell
												align="left"
												className="text-primary fw-bold"
											>
												Documento
											</TableCell>

											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												F.Nacimiento
											</TableCell>

											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Sector Negocio
											</TableCell>

											<TableCell
												align="left"
												className="text-primary fw-bold"
											>
												Direccion
											</TableCell>

											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Telefono
											</TableCell>

											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Telefono 2
											</TableCell>

											<TableCell
												align="left"
												className="text-primary fw-bold"
											>
												Empresa Trabajo
											</TableCell>

											<TableCell
												align="left"
												className="text-primary fw-bold"
											>
												Direccion Empresa
											</TableCell>
											<TableCell
												align="left"
												className="text-primary fw-bold"
											>
												Cargo
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												T.Ingresos
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												#Credito
											</TableCell>
											<TableCell
												align="left"
												className="text-primary fw-bold"
											>
												Nombre Tienda
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												F.Entrega
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Vendedor
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Plazo
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Frecuencia
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Cuota Teorica
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Cuota Credito
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Tasa Int.
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Vence
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Dias Mora
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												Rango Mora
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												F.Ultimo Pago
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{data.map((row) => {
											const {
												actividadEconomica,
												address,
												atrasoDias,
												clientName,
												company,
												companyAddress,
												cuotaPagar,
												cuotaTeorica,
												description,
												empresaPhone,
												fechaEntrega,
												fechaNacimiento,
												fechaUltimoAbono,
												fechaVencimiento,
												gestorName,
												identification,
												intCorriente,
												numeroCliente,
												numeroCredito,
												periocidad,
												phone,
												plazo,
												totalIngresos
											} = row;
											return (
												<TableRow key={row.id}>
													<TableCell
														align="center"
														component="th"
														scope="row"
														style={{ fontSize: 9 }}
													>
														{numeroCliente}
													</TableCell>

													<TableCell align="left" style={{ fontSize: 9 }}>
														{clientName}
													</TableCell>

													<TableCell align="left" style={{ fontSize: 9 }}>
														{identification}
													</TableCell>

													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{fechaNacimiento}
													</TableCell>

													<TableCell align="left" style={{ fontSize: 9 }}>
														{actividadEconomica}
													</TableCell>

													<TableCell align="left" style={{ fontSize: 9 }}>
														{address}
													</TableCell>

													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{phone}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														-
													</TableCell>
													<TableCell align="left" style={{ fontSize: 9 }}>
														{company}
													</TableCell>
													<TableCell align="left" style={{ fontSize: 9 }}>
														{companyAddress}
													</TableCell>
													<TableCell align="left" style={{ fontSize: 9 }}>
														{actividadEconomica}
													</TableCell>

													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(totalIngresos)}
													</TableCell>

													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{numeroCredito}
													</TableCell>

													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{description}
													</TableCell>

													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{fechaEntrega}
													</TableCell>
													<TableCell align="left" style={{ fontSize: 9 }}>
														{gestorName}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{plazo}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{periocidad}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(cuotaTeorica)}
													</TableCell>

													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(cuotaPagar)}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{`${intCorriente} %`}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{fechaVencimiento}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{atrasoDias}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{atrasoDias >= 0 && atrasoDias <= 30
															? '0 - 30'
															: atrasoDias > 30 && atrasoDias <= 60
															? '31 - 60'
															: atrasoDias > 60 && atrasoDias <= 90
															? '61 - 90'
															: atrasoDias > 91 && atrasoDias <= 120
															? '91 - 120'
															: '120+'}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
													>
														{fechaUltimoAbono}
													</TableCell>
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
							</TableContainer>
						</>
					)}
				</Container>
			</Dialog>
		</div>
	);
};

export default ReporteCarteraCredito;
